import { render, staticRenderFns } from "./msgDialog.vue?vue&type=template&id=a3834d96&scoped=true&"
import script from "./msgDialog.vue?vue&type=script&lang=js&"
export * from "./msgDialog.vue?vue&type=script&lang=js&"
import style0 from "./msgDialog.vue?vue&type=style&index=0&id=a3834d96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3834d96",
  null
  
)

export default component.exports